import { render, staticRenderFns } from "./AmpliarFoto.vue?vue&type=template&id=01cd12dc&scoped=true&"
import script from "./AmpliarFoto.vue?vue&type=script&lang=js&"
export * from "./AmpliarFoto.vue?vue&type=script&lang=js&"
import style0 from "./AmpliarFoto.vue?vue&type=style&index=0&id=01cd12dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd12dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSpacer,VToolbar})
